/* @flow */
import idx from 'idx';
import React from 'react';
import { graphql } from 'react-apollo';

import QUERY from '../queries/OrganizationDeveloperConsoleAuthorizerQuery.gql';

import type { OrganizationDeveloperConsoleAuthorizer as OrganizationDeveloperConsoleAuthorizerQuery } from '../queries/__generated__/OrganizationDeveloperConsoleAuthorizer';

type Props = {
  children: *,
  uuid: string,
  data: ReactApolloData<OrganizationDeveloperConsoleAuthorizerQuery>,
};

const isAuthorized = (o: any) => o.permissions.canEditDeveloperSettings;

class OrganizationDeveloperConsoleAuthorizer extends React.Component<Props, {}> {
  render() {
    if (this.props.data.loading) {
      return null;
    }

    const organization = idx(this.props, _ => _.data.organizations[0]);
    return this.props.children({ authorized: organization && isAuthorized(organization) });
  }
}

const withTheOrganization = graphql(QUERY, {
  options: ({ uuid }) => ({
    variables: { uuid },
  }),
});

export default withTheOrganization(OrganizationDeveloperConsoleAuthorizer);
